import { List } from 'immutable';
// Todo: convert immutables
export const deriveNestedUserIds = (teams, teamId) => {
  const team = teams.get(teamId);
  let ownerIds = team === null || team === void 0 ? void 0 : team.get('userIds', List());
  team.get('childTeams', List()).forEach(id => {
    ownerIds = ownerIds.concat(deriveNestedUserIds(teams, id));
  });
  return ownerIds;
};